import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';

import { BaseListApiService } from '../../../_common/api/base-list-api.service';
import { ResultApi } from 'src/app/_common/api/result-api';
import { AppConstants } from '../../app.constants';
import { ChargedCapacityApi } from './models/charged-capacity-api';
import { BckpConstants } from '../bckp.constants';
import { QueryString } from 'src/app/_common/api/qs/query-string';

@Injectable({
    providedIn: 'root'
})
export class ChargedCapacityListApiService extends BaseListApiService<ChargedCapacityApi>
{
    private endPoint = '/chargedcapacities';

    constructor (http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlHist;
        this.resourceUrl = '/hist/netbackup';
    }

    getChargedCapacities (since: string, until: string, servers: string): Observable<ResultApi<ChargedCapacityApi>>
    {
        if (AppConstants.IsDataLocal('bckp'))
        {
            return this.http.get<ResultApi<ChargedCapacityApi>>('assets/data/bckp/capacities.json');
        }

        const queryString = new QueryString();


        queryString.pushValue('since', since);
        queryString.pushValue('until', until);
        queryString.pushValue('$top', BckpConstants.NbServerPerChargedCapacity);
        queryString.pushValue('terms', `serverShort:${servers}`);

        // if (AppConstants.IsDebugStage)
        // {
        //     const headers = new HttpHeaders()
        //         .set('X-AurorA-EntityId', 'f9244225-04e3-e511-80cd-005056ae7252');

        //     return this.getAll(`${this.resourceUrl}${this.endPoint}${queryString.qs}`, headers);
        // }

        return this.getAll(`${this.resourceUrl}${this.endPoint}${queryString.qs}`);
    }
}
